export default __webpack_public_path__ + "static/media/btn-color-kr_kr@3x.59f3a6b1.png";